import { useEffect } from 'react';

import { useIsAnyUploadInProgress } from '@/store/useUploadStateStore';

/**
 * Component that warns users when they try to close or refresh the browser
 * while an upload is in progress. Uses the native browser beforeunload event.
 *
 * This component renders nothing - it only sets up event listeners.
 *
 * @returns Null - no visual output.
 *
 * @example
 * ```tsx
 * <UploadExitWarning />
 * ```
 */
export function UploadExitWarning() {
  const isUploadInProgress = useIsAnyUploadInProgress();

  useEffect(() => {
    function handleBeforeUnload(event: BeforeUnloadEvent) {
      event.preventDefault();
      event.returnValue = '';
    }

    if (isUploadInProgress) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isUploadInProgress]);

  return null;
}
